import { formatMoney, formatSortCode } from 'lib/utils';
import { accountRolesLookup, currencies } from 'lib/constants';
import useTranslate from 'lib/languages/useTranslate';
import { toCamelCase } from 'utils/generic';

const AccountOverview = ({ account }) => {
    const {
        accountName,
        productType,
        bankAccountNo,
        sortCode,
        availableBalance,
        clearedBalanceCurrencyCode,
    } = account || {};
    const translate = useTranslate('accountOverview');
    return (
        <div className="account-overview-container">
            <div className="account-select">
                <div className="account-details-wrapper">
                    <p>
                        <strong>
                            {accountName || 'Unknown'} -{' '}
                            {translate(
                                toCamelCase(
                                    accountRolesLookup[productType] || '',
                                ),
                            )}
                        </strong>
                    </p>
                </div>
                <p className="account-number">
                    {translate('accountNo', {
                        bankAccountNo,
                        sortCode: formatSortCode(sortCode),
                    })}
                </p>
            </div>
            <p className="amount-label">{translate('amountLabel')}</p>
            <p className="amount">
                <strong>
                    {currencies[clearedBalanceCurrencyCode]}
                    {formatMoney(availableBalance)}
                </strong>
            </p>
        </div>
    );
};

export default AccountOverview;
